import { useState, useEffect } from 'react'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { createContact } from '../apis/contactSlice'
import { errorHandling, openNotification } from '@/utils/utils'
import useTranslation from '@/hooks/useTranslation'

import { AppModal } from '@/components/shared-components'
import InputNormal from '@/components/shared-components/form/Input'
import TextArea from '@/components/shared-components/form/TextArea'
import InstantUploadGeneral from '@/components/shared-components/form/InstantUploadGeneral'
import Send from '@/components/svgs/Send'

export default function GetHelp({ open, setOpen }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { profile } = useSelector((state) => state.auth)
  const { loading, errors } = useSelector((state) => state.contact)

  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    subject: '',
    body: '',
    files: [],
    use_email: 0,
  })

  // SETTING PROFILE VALUES
  useEffect(() => {
    if (profile) {
      setFormValues({
        name: `${profile.name} ${profile.lname}`,
        email: profile.email,
        subject: '',
        body: '',
        files: [],
        use_email: 0,
      })
    }
  }, [profile])

  // SUBMITING FORM
  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(createContact(formValues))
      .unwrap()
      .then((data) => {
        openNotification('success', data.message)
        setOpen(false)
        setFormValues({
          name: `${profile.name} ${profile.lname}`,
          email: profile.email,
          subject: '',
          body: '',
          use_email: 0,
        })
      })
      .catch((error) => openNotification('error', errorHandling(error)))
  }

  return (
    <AppModal
      open={open}
      setOpen={setOpen}
      icon={<Send color='#8FC045' width='72' height='72' />}
      title={t('Get help')}
      description='Non esitare a contattarci. Siamo qui per aiutarti!'
    >
      <form onSubmit={handleSubmit} className='form-type_5'>
        <InputNormal
          label={`${t('Subject')}*`}
          placeholder={t('Subject')}
          name='subject'
          value={formValues.subject}
          onChange={(e) =>
            setFormValues({ ...formValues, subject: e.target.value })
          }
          error={errors?.subject}
          style='mb-16'
        />

        <TextArea
          label={`${t('contactUs.form.label.desc')}*`}
          placeholder='Scrivi...'
          name='body'
          value={formValues.body}
          onChange={(e) =>
            setFormValues({ ...formValues, body: e.target.value })
          }
          error={errors?.body}
          style='mb-24'
        />

        <InstantUploadGeneral
          files={formValues.files}
          setFiles={(files) => setFormValues({ ...formValues, files: files })}
        />

        <Button
          className='btn-green text-base font-semibold rounded-lg py-12 w-full h-auto mt-16'
          loading={loading}
          htmlType='submit'
        >
          {t('contactUs.form.submit')}
        </Button>
      </form>
    </AppModal>
  )
}
